import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import Button from "components/UI/Button";
import useWindowWidth from "hooks/useWindowWidth";

const Banner = ({
  title,
  description,
  image,
  buttonText,
  buttonUrl,
  readTime,
  alt = false,
}) => {
  const width = useWindowWidth();

  const imageLayout = alt ? (
    <img
      width={"350"}
      height={"250"}
      src={image}
      alt={title}
      className={styles.imageAlt}
    />
  ) : width > 700 ? (
    <div className={styles.imageWrapper}>
      <img
        width={"160"}
        height={"160"}
        src={image}
        alt={title}
        className={styles.image}
      />
    </div>
  ) : null;

  return (
    <div className={classNames(styles.banner, alt && styles.bannerAlt)}>
      <div className={classNames(alt ? styles.contentAlt : styles.content)}>
        {readTime && <div className={styles.readTime}>{readTime}</div>}
        <div className={classNames(styles.title, alt && styles.titleAlt)}>
          {title}
        </div>
        {description && <p className={styles.description}>{description}</p>}
        {buttonText && (
          <a href={buttonUrl} className={styles.buttonWrapper}>
            <Button title={buttonText} />
          </a>
        )}
      </div>
      {imageLayout}
    </div>
  );
};

export default Banner;
